export const AddIcon = () => (
  <svg viewBox="0 0 32 32" fill="currentColor">
    <polygon points="24,15 17,15 17,8 15,8 15,15 8,15 8,17 15,17 15,24 17,24 17,17 24,17" />
  </svg>
);
